declare global {
  interface Window {
    KhakhamAnalytics?: { allowRestroom(id: number): void };
  }
}

/** Authorize a public API result before native history changes; never send an event or row data. */
export function allowPublicRestroom(id: number): void {
  window.KhakhamAnalytics?.allowRestroom(id);
}
